import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import PropTypes from "prop-types";

import { motion } from "framer-motion";

import MDBox from "components/MDBox";

import { useMaterialUIController, setLayout } from "context";

import MainHeader from "components/MainNavbar/MainHeader";

import { IconButton } from "@mui/material";

import Toolbar from "@mui/material/Toolbar";

import bgImage from "assets/landingimages/images/weblogin1_bg.jpg";

import { FaHome, FaUser, FaCog } from "react-icons/fa";

import Sidebar from "components/Sidebar";

import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { ptBR } from "date-fns/locale";

function HomePageLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();

  const { pathname } = useLocation();

  const pxToRem = (px) => `${px / 16}rem`;

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  const popupAnimation = {
    hidden: { opacity: 0, y: 10 },

    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeInOut" } },

    exit: { opacity: 0, y: 10, transition: { duration: 0.4, ease: "easeInOut" } },
  };

  return (
    <MDBox
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        backgroundImage: `linear-gradient(90deg,rgb(216, 218, 229), #fbeeff)`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        transition: transitions.create("background-color", {
          easing: transitions.easing.easeInOut,
          duration: transitions.duration.standard,
        }),
        width: "100%",
        height: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        [breakpoints.down("sm")]: {
          backgroundImage: `linear-gradient(90deg, #ffffff, #fbeeff)`, // Softer gradient for mobile
        },
      })}
    >
      <MainHeader />
      <Toolbar />
      <MDBox
        sx={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
          width: "100%",
          flexGrow: 1,
          overflow: "hidden",
        }}
      >
        <MDBox
          sx={{
            flex: 1, // Occupies full available space
            height: "100%", // Full height within parent
            overflow: "hidden", // Prevents horizontal jerking
            display: "flex", // Ensures children stretch properly
            flexDirection: "column",
          }}
        >
          <motion.div
            key={pathname}
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={popupAnimation}
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              height: "100%",
              width: "100%",
              overflowY: "auto",
            }}
          >
            {children}
          </motion.div>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}

HomePageLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HomePageLayout;
